// extracted by mini-css-extract-plugin
module.exports = {"root":"Comment__root--1FLSk"};